// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

export type IndustryTypeEnum =
    | 'THIRD_PARTY_LOGISTICS'
    | 'FMCG'
    | 'RETAIL'
    | 'SERVICE';
export type BusinessUnitStatusEnum = 'ACTIVE' | 'INACTIVE';

export type BusinessUnitListModelType = {
    businessUnits: Array<BusinessUnitModelType>
};

export type BusinessUnitModelType = {
    clientId: string,
    businessUnitId: string,
    name: string,
    shortName: string,
    description: string,
    color: string,
    status: BusinessUnitStatusEnum,
    industryType: IndustryTypeEnum,
    version: number
};

export type BusinessUnitIdModelType = {
    clientId: string,
    businessUnitId: string
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class BusinessUnitList extends ImmutableModel {
    static fromJS(json: BusinessUnitListModelType): BusinessUnitList {
        const state: Object = Object.assign({}, json);
        state.businessUnits = Immutable.List(state.businessUnits).map(item =>
            BusinessUnit.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): BusinessUnitListModelType {
        return {
            businessUnits: this.businessUnits.toArray().map(item => item.toJS())
        };
    }

    get businessUnits(): Immutable.List<BusinessUnit> {
        return this._state.get('businessUnits');
    }

    setBusinessUnits(businessUnits: Immutable.List<BusinessUnit>): this {
        return this.clone(this._state.set('businessUnits', businessUnits));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class BusinessUnit extends ImmutableModel {
    static fromJS(json: BusinessUnitModelType): BusinessUnit {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): BusinessUnitModelType {
        return {
            clientId: this.clientId,
            businessUnitId: this.businessUnitId,
            name: this.name,
            shortName: this.shortName,
            description: this.description,
            color: this.color,
            status: this.status,
            industryType: this.industryType,
            version: this.version
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get businessUnitId(): string {
        return this._state.get('businessUnitId');
    }

    setBusinessUnitId(businessUnitId: string): this {
        return this.clone(this._state.set('businessUnitId', businessUnitId));
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get shortName(): string {
        return this._state.get('shortName');
    }

    setShortName(shortName: string): this {
        return this.clone(this._state.set('shortName', shortName));
    }

    get description(): string {
        return this._state.get('description');
    }

    setDescription(description: string): this {
        return this.clone(this._state.set('description', description));
    }

    get color(): string {
        return this._state.get('color');
    }

    setColor(color: string): this {
        return this.clone(this._state.set('color', color));
    }

    get status(): BusinessUnitStatusEnum {
        return this._state.get('status');
    }

    setStatus(status: BusinessUnitStatusEnum): this {
        return this.clone(this._state.set('status', status));
    }

    get industryType(): IndustryTypeEnum {
        return this._state.get('industryType');
    }

    setIndustryType(industryType: IndustryTypeEnum): this {
        return this.clone(this._state.set('industryType', industryType));
    }

    get version(): number {
        return this._state.get('version');
    }

    setVersion(version: number): this {
        return this.clone(this._state.set('version', version));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class BusinessUnitId extends ImmutableModel {
    static fromJS(json: BusinessUnitIdModelType): BusinessUnitId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): BusinessUnitIdModelType {
        return {
            clientId: this.clientId,
            businessUnitId: this.businessUnitId
        };
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get businessUnitId(): string {
        return this._state.get('businessUnitId');
    }

    setBusinessUnitId(businessUnitId: string): this {
        return this.clone(this._state.set('businessUnitId', businessUnitId));
    }
}
